import { UseMutateFunction, useMutation, useQueryClient } from "react-query";

import { QUERY_STRINGS } from "../../constants";
import requirementsService from "../../services/requirements";
import { SnackbarState, useSnackbar } from "../../store/useSnackbar";
import { ErrorContent } from "../../types/default";
import { EditRequirement } from "../../types/requirements";

interface ReturnType {
  editJobRequirement: UseMutateFunction<void, ErrorContent, EditRequirement, unknown>;
  isLoading: boolean;
}

const addSnackbarSelector = (state: SnackbarState) => state.addSnackbar;

export const useEditJobRequirement = (): ReturnType => {
  const addSnackBar = useSnackbar(addSnackbarSelector);

  const queryClient = useQueryClient();

  const { mutate: editJobRequirement, isLoading } = useMutation(requirementsService.editSuperadminJobRequirement, {
    mutationKey: QUERY_STRINGS.EDIT_REQUIREMENT,
    onError: (error: ErrorContent) => addSnackBar({ text: error.message }),
    onSuccess: () => queryClient.invalidateQueries(QUERY_STRINGS.GET_REQUIREMENTS),
  });

  return { editJobRequirement, isLoading };
};
